import reduceWithSeparator from '@/helpers/reduce-with-separator'

export default {
  afterPrepareShow () {
    this.speciality = reduceWithSeparator(this.specialities, 'name')
  }
}



// WEBPACK FOOTER //
// ./src/app/team/dashboard/gadget/components/identification/resources/methods.js